
<main class="reference_form-main">
    <div class="main_container">
      <form [formGroup]="stakeholderRepForm">
      <div class="" *ngIf="selectedStakeholder">
        <h3 class="form_name">Stakeholder Representative ({{selectedStakeholderName}})</h3>
  
  
          <div class="input">
            <label for="">Name (<span style="color:red">*</span>)</label>
            <input type="text" class="default_input reference-form" formControlName="StakeholderRepName" />
            <label for="">Telepone</label>
            <input type="text" class="default_input reference-form" formControlName="StakeholderRepPhone" />
            <label for="">Email (<span style="color:red">*</span>)</label>
            <input type="text" class="default_input reference-form" formControlName="StakeholderRepEmail" />
            <label for="">Designation</label>
            <input type="text" class="default_input reference-form" formControlName="StakeholderRepDesignation" />
            <label for="">Rep Status</label>
            <!-- <input type="text" class="default_input reference-form" formControlName="StakeholderRepStatus" /> -->
            <select  class="form-control" formControlName="StakeholderRepStatus" #status placeholder="Select Status "
                                              style="width: 100%">
                                              <option value="">select Status</option>                                                         
                                               <option value="Active" >Active</option>
                                               <option value="Inactive">In Active</option>
                                            </select>
          </div>
  
  
        <div class="btn_holder">
          <button class="default_primary-button" (click)="addNew(stakeholderRepForm.value)">Add</button>
          <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>
  
        </div>
  
      </div>
    </form>
      <div class="display_table" >
        <div class="search_container">
          <input type="text" class="default_input search"
          placeholder="Search for Stakeholder"
          [formControl]="control"
          [appAutocomplete]="autocomplete"
          />
          <em class="ti-search"></em> 
  
          <app-autocomplete #autocomplete="appAutocomplete">
            <ng-template appAutocompleteContent>
              <ng-container
                *ngIf="(stakeholders | filterReference: control.value) as result"
              >
                <app-option
                  (click)="selectStakeholder(option.id)"
                  *ngFor="let option of result"
                  [value]="option.PipelineLicenseStakeholderName"
                >
                  {{ option.PipelineLicenseStakeholderName }}
                </app-option>
                <app-option class="no-result" *ngIf="!result.length"
                  >No result...</app-option
                >
              </ng-container>
            </ng-template>
          </app-autocomplete>
        </div>
  
        <div class="head" >
          <span class="item">S/N</span>
          <span class="item">Name</span>
          <span class="item">Telephone</span>
          <span class="item">Email</span>
          <span class="item">Designation</span>
            <span class="item">Rep Status</span>
          <span class="item">Action</span>
  
        </div>
  
      <div class="scroll">
  
      </div>
      <div class="body_content" *ngIf="status">
        <div class="the_body"
        *ngFor="let stakeholder of stakeholderRepFormArray.get('StakeholderReps')['controls']; index as i"
        (click)="onEdit(i, stakeholder.value)" style="cursor: pointer;"
        matTooltip="Click to edit"
          aria-label="Button that displays a tooltip when focused or hovered over"
        >
          <span class="content">{{i + 1}}</span>
          <span class="content">{{stakeholder.value.StakeholderRepName}}</span>
          <span class="content">{{stakeholder.value.StakeholderRepPhone}}</span>
          <span class="content">{{stakeholder.value.StakeholderRepEmail}}</span>
          <span class="content">{{stakeholder.value.StakeholderRepDesignation}}</span>
           <span class="content">{{stakeholder.value.StakeholderRepStatus}}</span>
          <span class="content" (click)="$event.stopImmediatePropagation()">
            <button
            class="delete_icon trash"
  
            (click)="deleteStakeholderRep(i, stakeholder.value)">
            <em class="ti-trash"> </em> </button>
          </span>
  
        </div>
        </div>
        <div class="btn_holder">
          <button class="default_primary-button" (click)="onSubmit(stakeholderRepFormArray.value)">Submit</button>
        </div>
      </div>
    </div>
  </main>
  
  <div class="box green_box"></div>
  <div class="box pink_box"></div>
  
